const
  orderLengthAction = orderLength => ({
    orderLength,
    type: 'ORDERLENGTH'
  }),
  holidaysAction = holidays => ({
    holidays,
    type: 'HOLIDAYS'
  }),
  ticketObjectAction = ticketObject => ({
    ticketObject,
    type: 'TICKETOBJECT'
  });

export { orderLengthAction, ticketObjectAction, holidaysAction }
